<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                Report Footers</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">Report Footers Data</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    Add New Record
                                </button>
                                <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg" (click)="
                                        download()">
                                    <i class="fe fe-download-cloud me-2"></i> {{'header.enrollment.titleList.DownloadReport' | translate}}
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu> -->
                            </div>
                        </div>
                    </div>
                    <!-- list of faculty start  -->

                    <!-- list of faculty end  -->
                    <!-- add of faculty start  -->
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="RepFooter">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>Add New Report Footer</b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                Add New Report Footer Information</p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>Update Selected Report Footer</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                Update Selected Report Footer Information
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>Delete Selected Report Footer</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                Delete Selected Report Footer Information
                                            </p>
                                        </div>
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                  <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width mt-2" >
                                                      <mat-label>
                                                        Report Name
                                                      </mat-label>
                                                      <!-- <input matInput formControlName="CoGPAm" placeholder="CoGPAm"required> -->
                                                      <mat-select #select56 class="colorblack" formControlName="RhRptCode">
                                                        <mat-select-filter *ngIf="select56.focused" [placeholder]="'Filter'"
                                                          [displayMember]="'RptName'" [array]="reportList"
                                                          (filteredReturn)="filteredListReport =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListReport" [value]="item.RptCode" (click)="getCode(item.RptCode)">
                                                          {{item.RptCode}} - {{item.RptName}}
                                                        </mat-option>
                                                      </mat-select>
                                                      
                                                    </mat-form-field>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="form-group">
                                                  <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width mt-2" >
                                                      <mat-label>
                                                        Exam
                                                      </mat-label>
                                                      <!-- <input matInput formControlName="CoGPAm" placeholder="CoGPAm"required> -->
                                                      <mat-select #select56 class="colorblack" formControlName="RhEmId">
                                                        <mat-select-filter *ngIf="select56.focused" [placeholder]="'Filter'"
                                                          [displayMember]="'EmName'" [array]="examList"
                                                          (filteredReturn)="filteredListExam =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListExam" [value]="item.EmId" (click)="getEmId(item.EmId)">
                                                          {{item.EmCode}} - {{item.EmName}}
                                                        </mat-option>
                                                      </mat-select>
                                                      
                                                    </mat-form-field>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text btn-raised g-bg-blush2" (click)="list()">
                                                List</button>
                                              </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-4">
                                                <mat-checkbox class="example-margin" formControlName="Seq">
                                                    Sequence
                                                </mat-checkbox>
                                            </div>
                                            <div class="col-sm-4 mt-2">
                                                <div class="form-group">
                                                    <mat-label></mat-label>
                                                    <mat-radio-group formControlName="RhHdrFtr"
                                                        class="example-full-width">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-1 ">
                                                                <mat-radio-button value='H'>Header</mat-radio-button>
                                                            </div>
                                                            <div class="col-sm-4 p-1 ">
                                                                <mat-radio-button
                                                                    value='F'>Footer</mat-radio-button>
                                                            </div>
                                                        </div>
                                                    </mat-radio-group>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="row clearfix">

                                           <div class="col-sm-8">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Text</mat-label>
                                                <textarea matInput formControlName="RhHeader" rows="6" cols="100" placeholder="Enter text"></textarea>
                                              </mat-form-field>
                                           </div>
                                        </div>
                                        
                                        <div class="col-sm-12">
                                            <!-- *ngIf="submitButton" -->
                                            <button type="button" *ngIf="New"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                (click)="NewBtn()">New</button>
                                            <button type="button" *ngIf="submitButton"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                (click)="submit()">Submit</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="editButton">Update</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="deleteButton">Delete</button>
                                            <button type="button"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                (click)="addnewrecord('false')">Back</button>
                                        </div>
                                        <div class="table-responsive">
                                            <table id="datatable"
                                                class="table table-striped table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr>

                                                        <th class="f600">
                                                            H/F
                                                        </th>
                                                        <th class="f600">
                                                            Seq
                                                        </th>
                                                        <th class="f600">
                                                            Text
                                                        </th>
                                                        
                                                        <th width="10%" class="f600 text-center">
                                                            {{'header.enrollment.table.Action' | translate}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr *ngFor="let report of reportHeadList;">
                                                        <td>
                                                            {{report.RhHdrFtr}}
                                                        </td>
                                                        <td>
                                                            {{report.Seq}}
                                                        </td>
                                                        <td>
                                                            {{report.RhHeader}}
                                                        </td>
                                                        <td class="text-center">

                                                            <a class="btn-floating" title="Edit"
                                                                (click)="edit('true',report)">
                                                                <!--  -->
                                                                <i class="fa fa-edit"></i>
                                                            </a>
                                                            
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>